import React from 'react';
import PropTypes from 'prop-types';

import * as hardwareAccessCheckConstants from '../../../../services/livesession/HardwareAccessCheckConstants';

import PlayTestSoundButton from './PlayTestSoundButton';
import SoundButton from './SoundButton';

class PlayTestSoundButtonWithAudio extends React.PureComponent {
    static propTypes = {
        speakerDeviceId: PropTypes.string,
    };

    static defaultProps = {
        speakerDeviceId: null,
    };

    render() {
        const { speakerDeviceId } = this.props;

        // source element order matters: the first compatible media will be used
        return (
            <SoundButton
                button={PlayTestSoundButton}
                speakerDeviceId={speakerDeviceId}
            >
                <source
                    src={hardwareAccessCheckConstants.testSoundUrlWebm}
                    type="audio/webm; codecs=opus"
                />
                <source
                    src={hardwareAccessCheckConstants.testSoundUrlMp3}
                    type="audio/mp3"
                />
            </SoundButton>
        );
    }
}

export default PlayTestSoundButtonWithAudio;
